import slugify from 'slugify';

export default class UtilString {

  /**
   * Slugify a string. For example from "Some str'ng!" to "some-strng"
   */
  static slugify(string: string) {
    return slugify(string, { lower: true, strict: true });
  }

}
